type AppIconProps = {
  className?: string
}

export function AppIcon({ className = "h-9 w-9" }: AppIconProps) {
  return (
    <img
      alt=""
      aria-hidden="true"
      className={`${className} rounded-md border bg-secondary object-cover shadow-sm`}
      src="/icon.png"
    />
  )
}
